import { render, staticRenderFns } from "./TenderOffersVersionsList.vue?vue&type=template&id=6fbdae84&"
import script from "./TenderOffersVersionsList.vue?vue&type=script&lang=js&"
export * from "./TenderOffersVersionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports